import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

@Component({
	selector: 'app-password',
	templateUrl: './password.html',
	styleUrls: ['./../opzioni.css']
})

export class PasswordComponent {

	@ViewChild('loading')
	loading: TemplateRef<any>;

	error = false;

	codice_fiscale: string;
	passwordOld: string;
	passwordNew: string;
	passwordNew2: string;
	show: boolean = false;
	changing: Subscription;
	formGroup = new FormGroup({
		codice_fiscale: new FormControl(),
		vecchia: new FormControl(), 
		nuova: new FormControl(), 
		nuova2: new FormControl() 
	});

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: NgbModal,
	) { }

	checkOldPwd() {
		return this.passwordOld != null;
	}

	newPwdEqual() {
		return this.passwordNew == this.passwordNew2 && this.passwordNew != null && this.passwordNew2 != null;
	}

	check() {
		return this.checkOldPwd() && this.newPwdEqual();
	}

	confirm() {
		const modalRef = this.modalService.open(
			this.loading, 
			{ backdrop: 'static' }
		);

		// FIXME: capire cosa fa questo pezzo di codice
		/*this.changing = this.authService.reset_password({
			codice_fiscale: this.codice_fiscale,
			password_vecchia: this.passwordOld,
			password_nuova: this.passwordNew
		}).subscribe({
			next: () => {
				modalRef.close();
				this.activeModal.close();
			},
			error: () => {
				this.error = true;
				modalRef.close();
			}
		});*/
	}
}


// WEBPACK FOOTER //
// ./src/app/opzioni/password/password.ts